import { useState } from 'react';
import type { Experience } from '@/features/experiences/types/experience.types';

export interface ExperienceDialogState {
  open: boolean;
  setOpen: (open: boolean) => void;
  mode: 'create' | 'edit';
  experience: Experience | null;
  openCreate: () => void;
  openEdit: (experience: Experience) => void;
}

export function useExperienceDialog(): ExperienceDialogState {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState<'create' | 'edit'>('create');
  const [experience, setExperience] = useState<Experience | null>(null);

  const openCreate = (): void => {
    setMode('create');
    setExperience(null);
    setOpen(true);
  };
  const openEdit = (next: Experience): void => {
    setMode('edit');
    setExperience(next);
    setOpen(true);
  };

  return { open, setOpen, mode, experience, openCreate, openEdit };
}
